import SubagentManager from '../../components/modals/SubagentManager';

export default function SubagentPage() {
  return <SubagentManager open={true} onClose={() => {}} inline />;
}
